export default {
  LOAD_STREAM (state, payload) {
    state.stream = payload
  },
  LOAD_STREAM_ENTITY (state, payload) {
    state.entity = payload
  },
  LOAD_SHOW_ENTITY (state, payload) {
    state.showEntity = payload
  },
  LOAD_SHOW_CATEGORY (state, payload) {
    state.showCategory = payload
  },
  LOAD_CATEGORY (state, payload) {
    state.category = payload
  },
  LOAD_STREAM_PLANNER (state, payload) {
    state.planner = payload
  },
  LOAD_ACADEMIC_YEARS (state, payload) {
    state.academicYears = payload
  },
  LOAD_TERMS (state, payload) {
    state.terms = payload
  },
  LOAD_BLOCKS (state, payload) {
    state.blocks = payload
  },
  LOAD_ALUMNI_STREAM_RECOMMENDATIONS (state, payload) {
    state.alumniStreamRecommendations = payload
  },
  LOAD_ADVISOR_STREAM_RECOMMENDATIONS (state, payload) {
    state.advisorStreamRecommendations = payload
  },
  UPDATE_PLAN_STREAM_SEARCH_TYPE (state, payload) {
    state.planStreamSearchType = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/mutations.js